<div formGroupName="childReimportUsageConditionInfo">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-md:max-w-[full]"
            fxFlex="30" fxFlex.lt-md="100">
            <mat-label>供給地点特定番号</mat-label>
            <input [class.error]="suppntSpno.invalid && suppntSpno.touched" matInput
                formControlName="suppntSpno" type="text" inputmode="numeric" maxlength="22" autocomplete="off" />
        </mat-form-field>

        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]"
            fxFlex="30" fxFlex.lt-md="100">
            <mat-label>ステータス</mat-label>
            <mat-select formControlName="status">
                <mat-option *ngFor="let status of searchStatusList" [value]="status.value">
                    {{status.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right">
        <button type="submit" mat-raised-button color="primary" class="btn" (click)="onClickSearch()"
            [disabled]="parentForm.invalid">検索</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">クリア</button>
    </mat-card-actions>
</div>